import { Injectable } from '@angular/core';
import {screens} from '../../../conf/breakpoints';

@Injectable({
  providedIn: 'root'
})
export class BreakpointService {

  getBreakpoints() {
    return screens
  }

  getBreakpointValue(name: string): number {
    const value = screens[name];
    if (typeof value === 'string') {
      return parseInt(value.replace('px', ''));
    }
    return 0;
  }

  getCurrentBreakpoint(width: number): string {
    const breakpoints = Object.entries(screens)
      .map(([name, value]) => ({
        name,
        value: typeof value === 'string' ? parseInt(value.replace('px', '')) : 0
      }))
      .sort((a, b) => a.value - b.value);

    for (let i = breakpoints.length - 1; i >= 0; i--) {
      if (width >= breakpoints[i].value) {
        return breakpoints[i].name;
      }
    }
    return 'xs';
  }
}
